"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// arg could be any, so we need to find out what it is.
// tslint:disable-next-line:no-any
exports.isString = function (arg) { return Object.prototype.toString.call(arg) === '[object String]'; };
// tslint:disable-next-line:no-any
exports.isArray = function (arg) { return Object.prototype.toString.call(arg) === '[object Array]'; };
// tslint:disable-next-line:no-any
exports.isObject = function (arg) { return Object.prototype.toString.call(arg) === '[object Object]'; };



// WEBPACK FOOTER //
// ./src/dist/commonjs/utils.js